import { action, makeObservable } from 'mobx';

import agent from '../agent';

class DashboardStore {
    constructor() {
        makeObservable(this, {
            load: action,
            getDeviations: action,
            getSchedules: action
        });
    }

    load(params) {
        return agent.Dashboard.get(params)
            .then(
                action(list => {
                    return list;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    getDeviations() {
        return agent.Dashboard.getDeviations()
            .then(
                action(res => {
                    return res;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    getSchedules(params) {
        return agent.Dashboard.getSchedules(params)
            .then(
                action(res => {
                    return res;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }
}

const _DashboardStore = new DashboardStore();
export default _DashboardStore
